module.exports = __webpack_public_path__ + "95125dc709403ad2e5c23893d1640187.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/p-peel/restore.png
 ** module id = 476
 ** module chunks = 0
 **/